export const getWeaveToken = () => {
  return localStorage.getItem('weave_token');
};
